
import { useState } from 'react'

import { ApiCaller } from '@frontend/api'
import { useMessageContext } from '@ui/chat/modules/Message'
import { Tag } from '@ui/components'

export default function BrainsUsed() {
	const { message } = useMessageContext()
	const [showMore, setShowMore] = useState(false)
	const hasBrains = (message.selectedBrains && message.selectedBrains.length > 0) || message.openBrain

	if (!hasBrains) {
		return null
	}

	return (
		<div className="absolute bottom-[-15px] left-4 flex items-center max-w-full">
			<div className="flex items-center">
				{ message.openBrain
					? <Tag style="outline" customClass="h-[24px] items-center space-x-2 rounded-2xl p-1">
						{ message.openBrain === 'chatgpt' ? 'GPT-4o' : message.openBrain === 'perplexity' ? 'Perplexity' : '' }
					</Tag>
					: null }
				{
					message?.selectedBrains?.slice(0, 2).map(brain => (
						<Tag
							key={ brain.id }
							style="secondary"
							to={ { pathname: `/brains/${brain.id}` } }
							customClass="h-[24px] items-center self-start space-x-2 rounded-2xl p-1 max-w-[120px] min-w-[48px] truncate"
							onClick={ async () => ApiCaller.track('Brain_shortcut_access') }
						>
							<p className="text-sm" style={ { marginBottom: '-2px' } }>
								{ brain.name }
							</p>
						</Tag>
					))
				}
				{ message.selectedBrains?.length && message.selectedBrains.length > 2
					? <div className="relative">
						<Tag
							style="secondary"
							customClass="h-[24px] items-center space-x-2 rounded-2xl p-1 w-fit"
							onClick={ () => {
								setShowMore(prev => !prev)
							} }
						>
							<p className="text-sm" style={ { marginBottom: '-2px' } }>
										+{ message.selectedBrains.length - 2 }
							</p>
						</Tag>
						{ showMore
							? <div className="absolute z-50 bg-white border rounded-md shadow-sm mx-w-[200px] border-gray-200 mt-1 p-1">
								{ message.selectedBrains.slice(2).map((brain, index, array) => (
									<Tag
										key={ brain.id }
										style="secondary"
										to={ { pathname: `/brains/${brain.id}` } }
										customClass={ `h-[24px] items-center space-x-2 rounded-2xl p-1 w-fit truncate ${index < array.length - 1 ? 'mb-2' : ''}` }
										onClick={ async () => ApiCaller.track('Brain_shortcut_access') }
									>
										<p className="text-sm truncate">
											{ brain.name }
										</p>
									</Tag>
								)) }
							</div>
							: null }
					</div>
					: null }
			</div>
		</div>
	)
}
